<div
  class="palantir-expandable-input"
  (click)="inputElement.focus()"
  (keydown.enter)="inputElement.focus()"
  (onmouseleave)="onMouseLeave()"
  [class.expanded]="isOnFocus() || inputLength() > 0"
  [ngClass]="[
    'palantir-expandable-input--size-' + size,
    'palantir-expandable-input--growTo-' + growTo,
  ]"
>
  <palantir-icon class="palantir-expandable-input__icon" [name]="icon" />

  <input
    #inputElement
    (focus)="onFocus()"
    (blur)="onBlur()"
    class="palantir-expandable-input__input"
    type="text"
    [formControl]="control"
    placeholder="{{ placeholderText }}"
  />
</div>
